import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import adminService from '../../utils/adminService';
import '../../styles/ServicesList.css';

const ServicesList = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    loadServices();
  }, []);

  const loadServices = async () => {
    setLoading(true);
    const result = await adminService.getServices();
    
    if (result.success) {
      setServices(result.services);
    } else {
      setMessage({ type: 'error', text: result.message });
    }
    
    setLoading(false);
  };

  const handleToggleActive = async (id) => {
    const result = await adminService.toggleServiceActive(id);
    
    if (result.success) {
      setMessage({ type: 'success', text: 'Service status updated!' });
      loadServices();
    } else {
      setMessage({ type: 'error', text: result.message });
    }

    setTimeout(() => setMessage({ type: '', text: '' }), 3000);
  };

  const handleDelete = async (id, serviceName) => {
    if (window.confirm(`Are you sure you want to delete "${serviceName}"?`)) {
      const result = await adminService.deleteService(id);
      
      if (result.success) {
        setMessage({ type: 'success', text: 'Service deleted successfully!' });
        loadServices();
      } else {
        setMessage({ type: 'error', text: result.message });
      }

      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    }
  };

  if (loading) {
    return <div className="admin-loading">Loading services...</div>;
  }

  return (
    <div className="services-list-page">
      <div className="admin-header">
        <div>
          <h1>Services Management</h1>
          <p>Manage your service offerings, pricing, and images</p>
        </div>
        <Link to="/admin/services/new" className="btn btn-primary">
          ➕ Add New Service
        </Link>
      </div>

      {message.text && (
        <div className={`alert alert-${message.type}`}>
          {message.text}
        </div>
      )}

      {services.length === 0 ? (
        <div className="empty-state">
          <p>No services found</p>
          <Link to="/admin/services/new" className="btn btn-primary">
            Create your first service
          </Link>
        </div>
      ) : (
        <div className="services-grid">
          {services.map((service) => (
            <div key={service._id} className={`service-card ${!service.isActive ? 'inactive' : ''}`}>
              <div className="service-image">
                {service.image ? (
                  <img src={service.image} alt={service.name.en} />
                ) : (
                  <div className="service-icon-placeholder">{service.icon}</div>
                )}
              </div>

              <div className="service-content">
                <div className="service-header">
                  <h3>{service.name.en}</h3>
                  <span className={`service-status ${service.isActive ? 'active' : 'inactive'}`}>
                    {service.isActive ? '✓ Active' : '○ Inactive'}
                  </span>
                </div>

                <p className="service-description">{service.description.en}</p>

                <div className="service-meta">
                  <div className="service-price">
                    <strong>€{service.price}</strong>
                    <span className="service-duration">{service.duration} min</span>
                  </div>
                  <div className="service-category">
                    {service.category}
                  </div>
                </div>

                <div className="service-features">
                  <p><strong>Features:</strong></p>
                  <ul>
                    {service.features.slice(0, 2).map((feature, index) => (
                      <li key={index}>{feature.en}</li>
                    ))}
                  </ul>
                  {service.features.length > 2 && (
                    <p className="more-features">+{service.features.length - 2} more</p>
                  )}
                </div>

                <div className="service-actions">
                  <Link 
                    to={`/admin/services/edit/${service._id}`} 
                    className="btn btn-secondary btn-sm"
                  >
                    ✏️ Edit
                  </Link>
                  
                  <button
                    onClick={() => handleToggleActive(service._id)}
                    className="btn btn-secondary btn-sm"
                  >
                    {service.isActive ? '🔴 Deactivate' : '🟢 Activate'}
                  </button>
                  
                  <button
                    onClick={() => handleDelete(service._id, service.name.en)}
                    className="btn btn-danger btn-sm"
                  >
                    🗑️ Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ServicesList;
